// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileLayout_wrapper__6GGmU","title":"MobileLayout_title__K7u1j","loaderWrapper":"MobileLayout_loaderWrapper__GVAzl"};